<template>
  <svg
    xmlns="http://www.w3.org/2000/svg" data-name="그룹 80"
    width="20.789" height="20.325"
    viewBox="0 0 20.789 20.325"
  >
    <g data-name="그룹 63" style="clip-path:url(#qzpk2trpwa)">
      <path
        data-name="패스 40"
        d="M14.562 4.521V1.016A1.019 1.019 0 0 0 13.547 0H1.016A1.019 1.019 0 0 0 0 1.016v14.359a1.035 1.035 0 0 0 .542.9l7.721 4a.513.513 0 0 0 .745-.458v-3.9h4.538a1.018 1.018 0 0 0 1.016-1.017V9.347h-2.031v4.03a.5.5 0 0 1-.508.508h-3V5.266a1.034 1.034 0 0 0-.542-.9L3.929 2.032h8.094a.5.5 0 0 1 .508.509v2h2.032z"
      />
      <path
        data-name="패스 41"
        d="m18.949 3.3 3.3 3.3a1.012 1.012 0 0 1 0 1.473l-3.3 3.3a1.033 1.033 0 0 1-1.491.017 1.08 1.08 0 0 1 .034-1.49l1.49-1.473h-5.774a1 1 0 0 1-.762-.339 1.15 1.15 0 0 1 .254-1.745 1.086 1.086 0 0 1 .508-.135h5.774s-1.473-1.473-1.491-1.473A1.025 1.025 0 1 1 18.949 3.3"
        transform="translate(-1.778 -.434)"
      />
    </g>
  </svg>
</template>